import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export const BotsService = {
  getNodes: (data: any) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}bots/nodes/tree/${data.bot_id}`, {
      params: {
        is_sandox: data.is_sandox
      }
    });
  },
  saveNode: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}bots/nodes`, data);
  },
  updateNodeCoords: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}bots/nodes/coordinates`, data);
  },
  deleteNode: (data: any) => {
    return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}bots/nodes`, {
      data: {
        _id: data
      }
    });
  },
  setNodeRoot: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}bots/nodes/set-root`, data);
  },
  deployBot: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}bots/nodes/deploy`, data);
  },
  updateEdges: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}bots/nodes/edges`, data);
  },
  startFlow: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}bots/interaction/flow`, data);
  }
};
